import { Button } from 'services/types';

export enum MEDIA_TYPE {
  IMAGE = 'IMAGE',
  DOCUMENT = 'DOCUMENT',
}

export enum BUTTON_TYPE {
  URL = 'URL',
  QUICK_REPLY = 'QUICK_REPLY',
}

export interface ISharedWith {
  id: string;
  name: string;
}

export interface INotificationMessageProps {
  TemplateID: string;
  Header?: {
    Text?: string;
    Media?: {
      Type: string;
      Link: string;
      Caption?: string;
    };
  };
  Body: {
    Text: string;
  };
  Footer?: {
    Text: string;
  };
  Buttons?: Button[];
  createdAt: string;
}

export enum TypeAction {
  URL = 'URL',
  PHONE_NUMBER = 'PHONE_NUMBER',
  QUICK_REPLY = 'QUICK_REPLY',
  LIST = 'LIST',
}
